import { render, staticRenderFns } from "./NoDataInterface.vue?vue&type=template&id=6be9bdda&scoped=true&"
import script from "./NoDataInterface.vue?vue&type=script&lang=js&"
export * from "./NoDataInterface.vue?vue&type=script&lang=js&"
import style0 from "./NoDataInterface.vue?vue&type=style&index=0&id=6be9bdda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be9bdda",
  null
  
)

export default component.exports